<template>
  <div class="pagina-step">
    <span class="pagina-step-title">eMulti</span>
    <div class="container-table">
      <ValidationObserver ref="observer">
        <table>
          <tr>
            <th></th>
            <th></th>
          </tr>
          <tr v-for="(item, index) in equipes" :key="index">
            <td>{{ item.label }}</td>
            <td>
              <validation-provider v-slot="{ errors }" rules="required">
                <!-- <input
                  type="text"
                  v-model="item.value"
                  :name="`input_${index}`"
                  v-inputmask="maskNumbers"
                /> -->
                <money
                  v-model="item.value"
                  v-bind="money"
                  :name="`input_${index}`"
                ></money>

                <div class="error">{{ errors[0] }}</div>
              </validation-provider>
            </td>
          </tr>
        </table>
      </ValidationObserver>
    </div>
    <div class="container-buttons">
      <button type="button" @click="voltar">Voltar</button>
      <button @click="proximo">Avançar</button>
    </div>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()
import Masks from '@/mixins/masks'
import { Money } from 'v-money'

export default {
  components: {
    PulseLoader,
    'vue-select': VueSelect,
    ValidationObserver,
    ValidationProvider,
    Money,
  },
  props: {
    dados: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },
      loadingBtn: false,
      equipes: [
        {
          label: 'Custeio por atendimento remoto na eMulti',
          value: '',
          key: 'custeio_atendimento_remoto_emulti',
        },
        {
          label: 'Custeio eMulti',
          value: '',
          key: 'custeio_emulti',
        },
      ],
    }
  },
  mounted() {
    if (this.dados?.etapa9 !== null) {
      const etapa9 = this.dados?.etapa9
      this.equipes = etapa9.equipes
    }
  },
  computed: {
    maskNumbers() {
      return Masks['number']
    },
  },
  methods: {
    salvarDados() {
      this.$emit('dados-etapa', {
        etapa: 'etapa9',
        dados: {
          equipes: this.equipes,
        },
      })
    },

    voltar() {
      this.$emit('etapa-anterior')
    },

    proximo() {
      this.$refs.observer.validate().then(async (success) => {
        if (success) {
          this.salvarDados()
          this.$emit('ir-para-etapa', 11)
        } else {
          this.$toast.warning('Preencha os campos obrigatórios!', 'Erro:', {
            position: 'topRight',
          })
        }
      })
    },
  },
}
</script>
<style scoped lang="scss" src="./styles.scss" />

<style scoped lang="scss">
table {
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 30px;
  @media screen and (max-width: 656px) {
    margin-bottom: 0;
  }
}
th,
td {
  border: 1px solid black;
  padding: 8px;
  text-align: left;
  width: 50%;
  input {
    height: auto !important;
    background-color: #fff;
    margin-bottom: 0 !important;
  }
}
th {
  background-color: #156082;
  color: white;
}

.container-buttons {
  justify-content: center !important;
}

@media screen and (max-width: 656px) {
  .container-table {
    overflow: auto;
    margin-bottom: 15px;
  }
  .container-buttons {
    gap: 20px;
    align-items: center;
  }
}
</style>
